import React, { useEffect, useRef } from "react";
import { Button } from "reactstrap";
import { Html5Qrcode } from "html5-qrcode";
import classNames from "classnames";
import { addNotification } from "notificationStore";
import i18next from "i18next";

const qrCodeRegionId = "html5qr-code-region";
const qrCodeCameraPreferences = { facingMode: "environment" }; // prefer rear camera
const qrCodeConfig = {
  // Optional, frame per seconds for qr code scanning
  fps: 60,

  // Optional, if you want bounded box UI
  qrbox: { width: 500, height: 500 },
  formatsToSupport: ["UPC_A", "EAN_13"],
  // Show torch button if the device supports it
  showTorchButtonIfSupported: true
};

const BarcodeScanner = ({ isScanning, setIsScanning, successCallbackFn }) => {
  const barcodeScannerRef = useRef();

  const startBarcodeScanner = () => {
    barcodeScannerRef.current
      .start(qrCodeCameraPreferences, qrCodeConfig, qrCodeSuccessCallback)
      .then(() => {
        setIsScanning(true);
      })
      .catch(() => {
        addNotification({
          type: "danger",
          message: i18next.t("barcode.scannerStartFailed")
        });
      });
  };

  const stopBarcodeScanner = () => {
    const scanner = barcodeScannerRef.current;

    if (scanner?.isScanning) {
      scanner
        .stop()
        .then(() => {
          setIsScanning(false);
        })
        .catch(() => {
          addNotification({
            type: "danger",
            message: i18next.t("barcode.scannerStopFailed")
          });
        });
    }
  };

  const qrCodeSuccessCallback = (decodedText) => {
    successCallbackFn(decodedText);

    stopBarcodeScanner();
  };

  useEffect(() => {
    barcodeScannerRef.current = new Html5Qrcode(qrCodeRegionId);

    // startBarcodeScanner();

    return () => {
      stopBarcodeScanner();
    };
  }, []);

  return (
    <>
      <div className="text-center">
        {!isScanning && (
          <Button className="mr-4 my-auto" color="secondary" onClick={startBarcodeScanner}>
            Start camera scanner
          </Button>
        )}
      </div>

      <div className="text-center">
        {isScanning && (
          <Button className="mr-4 my-auto align-center" color="secondary" onClick={stopBarcodeScanner}>
            Stop camera scanner
          </Button>
        )}
      </div>

      <div className="d-flex justify-content-center">
        <div
          id={qrCodeRegionId}
          className={ classNames("mt-4 w-25") }
        ></div>
      </div>
    </>
  );
};

export default React.memo(BarcodeScanner);
